<script setup>
import { computed } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  content: { type: String, required: true },
  streaming: { type: Boolean, default: false },
  conversationInboxType: { type: String, default: '' },
});

const formatted = computed(
  () => new MessageFormatter(props.content).formattedMessage
);

const insertIntoRichEditor = computed(() =>
  [INBOX_TYPES.WEB, INBOX_TYPES.EMAIL].includes(props.conversationInboxType)
);

const useInEditor = () => {
  const event = insertIntoRichEditor.value
    ? BUS_EVENTS.INSERT_INTO_RICH_EDITOR
    : BUS_EVENTS.INSERT_INTO_NORMAL_EDITOR;
  emitter.emit(event, props.content);
};
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="flex flex-col gap-1 text-n-slate-12">
    <div class="font-medium">Helix</div>
    <div v-dompurify-html="formatted" class="prose-sm break-words" />
    <div v-if="!streaming" class="flex flex-row mt-1">
      <Button label="Usar no editor" faded sm slate @click="useInEditor" />
    </div>
  </div>
</template>
